import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBank = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		id: "government",
		clipPath: "url(#clip0_2229_103572)",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M18.3333 18.3333H17.4999V11.6658C18.4199 11.6625 19.1666 10.9142 19.1666 9.99333C19.1666 9.38 18.8316 8.81667 18.2941 8.525L11.1241 4.61417C11.0308 4.56333 10.9299 4.53667 10.8324 4.5V3.65L13.0283 2.2875C13.4408 2.0125 13.4316 1.40417 13.0116 1.14167L10.9599 0.179167C10.7724 0.0616667 10.5558 0 10.3341 0C9.68242 0 9.15325 0.528333 9.15325 1.18083V4.16667H9.16575V4.5C9.06825 4.5375 8.96742 4.56333 8.87408 4.61417L1.70575 8.525C1.16742 8.8175 0.833252 9.37917 0.833252 9.99333C0.833252 10.9142 1.58075 11.6625 2.49992 11.6658V18.3333H1.66659C1.20659 18.3333 0.833252 18.7058 0.833252 19.1667C0.833252 19.6275 1.20659 20 1.66659 20H18.3333C18.7941 20 19.1666 19.6275 19.1666 19.1667C19.1666 18.7058 18.7941 18.3333 18.3333 18.3333ZM9.16658 11.6667V18.3333H7.49992V11.6667H9.16658ZM10.8333 11.6667H12.4999V18.3333H10.8333V11.6667ZM14.1666 11.6667H15.8333V18.3333H14.1666V11.6667ZM4.16658 11.6667H5.83325V18.3333H4.16658V11.6667Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2229_103572",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "currentColor"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgBank);
export default ForwardRef;
